import React, { useState } from "react";
import {
  FaIndustry,
  FaFilter,
  FaCogs,
  FaBoxOpen,
  FaTrophy,
  FaCloud,
} from "react-icons/fa";
import TransparentButton from "component/misc/TransparentButton";
import TransparentCard from "component/misc/TransparentCard";
import IconWithBackground from "component/misc/IconWithBackground";

const ProcessSteps = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hoveredStep, setHoveredStep] = useState(null);
  const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });

  const steps = [
    {
      icon: (
        <IconWithBackground backgroundColor="linear-gradient(135deg, #4ECDC4, #44A08D)">
          <FaIndustry size={24} />
        </IconWithBackground>
      ),
      text: "Umwandlung",
      details: {
        title: "Umwandlung",
        description:
          "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Diam Nonumy Eirmod Tempor Invidunt Ut Labore Et Dolore Magna Aliquyam Erat, Sed Diam Voluptua.",
      },
    },
    {
      icon: (
        <IconWithBackground className="process-step-icon" backgroundColor="linear-gradient(135deg, #4ECDC4, #44A08D)">
          <FaTrophy size={24} />
        </IconWithBackground>
      ),
      text: "Gewinnung",
      details: {
        title: "Gewinnung",
        description: "Process details for Gewinnung step...",
      },
    },
    {
      icon: (
        <IconWithBackground backgroundColor="linear-gradient(135deg, #4ECDC4, #44A08D)">
          <FaFilter size={24} />
        </IconWithBackground>
      ),
      text: "Raffination",
      details: {
        title: "Raffination",
        description: "Process details for Raffination step...",
      },
    },
    {
      icon: (
        <IconWithBackground backgroundColor="#bdbdbd">
          <FaCogs size={24} />
        </IconWithBackground>
      ),
      text: "Veredelung",
      details: {
        title: "Veredelung",
        description: "Process details for Veredelung step...",
      },
    },
    {
      icon: (
        <IconWithBackground backgroundColor="#bdbdbd">
          <FaBoxOpen size={24} />
        </IconWithBackground>
      ),
      text: "Endprodukt",
      details: {
        title: "Endprodukt",
        description: "Process details for Endprodukt step...",
      },
    },
  ];

  const handleMainButtonClick = () => {
    setIsExpanded(!isExpanded);
  };

  const mainStep = steps[0];
  const expandingSteps = steps.slice(1);

  return (
    <div className="process-steps-container">
      {/* Process Steps Group with unified border */}
      <div className="process-steps-group">
        {/* Left, always visible part */}
        <div
          className={`process-step-main glass-card-ui ${isExpanded ? "expanded" : ""}`}
          onClick={handleMainButtonClick}
          onMouseEnter={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            setHoverPosition({
              x: rect.left,
              y: rect.bottom + 10,
            });
            setHoveredStep(0);
          }}
          onMouseLeave={() => {
            setHoveredStep(null);
          }}
        >
          {mainStep.icon}
          <span>{mainStep.text}</span>
        </div>

        {/* Middle, expanding part */}
        <div className={`process-steps-expanding-wrapper ${isExpanded ? "expanded" : ""}`}>
          {expandingSteps.map((step, index) => (
            <div
              key={index + 1}
              className="process-step"
              onMouseEnter={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                setHoverPosition({
                  x: rect.left,
                  y: rect.bottom + 10,
                });
                setHoveredStep(index + 1);
              }}
              onMouseLeave={() => {
                setHoveredStep(null);
              }}
            >
              <TransparentButton
                icon={step.icon}
                className="process-step-btn glass-card-ui"
                style={{ transitionDelay: `${index * 0.05}s` }}
              >
                {step.text}
              </TransparentButton>
            </div>
          ))}
        </div>
      </div>

      {/* Right, Co2 Value card - always visible */}
      <div className="co2-value-card glass-card-ui">
        <div className="co2-value-content">
          <span className="co2-value-label">Co2 Value</span>
          <div className="co2-value-data">
            <span className="co2-value-amount">1.456 Kg / mt</span>
            <FaCloud className="co2-value-icon" />
          </div>
        </div>
      </div>

      {hoveredStep !== null && steps[hoveredStep]?.details && (
        <div
          className="process-step-tooltip"
          style={{
            left: `${hoverPosition.x}px`,
            top: `${hoverPosition.y}px`,
          }}
        >
          <TransparentCard className="process-step-tooltip-card">
            <h6 className="process-step-tooltip-title">
              {steps[hoveredStep].details.title}
            </h6>
            <p className="process-step-tooltip-description">
              {steps[hoveredStep].details.description}
            </p>
          </TransparentCard>
          <div className="process-step-tooltip-arrow" />
        </div>
      )}
    </div>
  );
};

export default ProcessSteps;